export default __webpack_public_path__ + "static/media/Definix-Trading-Challenge-10.882e6ef1.png";